import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: []
})
export class ConfigurationComponent implements OnInit {
  constructor() {
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/configuration.component.ts